export default {
  triadList: "Liste der Trinômes",
  triadTrainingList: "Liste der Trinômes nach ",
  promotion: "Gruppe | Gruppen",
  youHaveAccess: "Sie haben derzeit Zugang zu {number} {label} {active} {filtered}",
  filtered: "gefilterte Ergebnisse",
  female_active: "aktiv | aktiv",
  male_active: "aktiv | aktiv",
  female_archived: "archiviert | archiviert",
  male_archived: "archiviert | archiviert",
  loadingTriads: "Trinômes werden geladen...",
  homeTriad: "Trinôme-Startseite",
  apprenticeShort: "A",
  tutorShort: "TP",
  apprenticeMasterShort: "AM",
  companyShort: "UNT",
  Apprentice: "Alternant",
  Tutor: "Betreuer",
  "Apprentice master": "Ausbildungsmeister",
  "Apprentice master 2": "Ausbildungsmeister 2",
  "Company manager": "Unternehmensverwalter",
  Parent: "Elternteil",
  "Studea manager": "Pilot",
  apprentices: "Alternants",
  tutors: "Betreuer",
  apprenticeMasters: "Ausbildungsmeister",
  studeaManagers: "Heft-Verantwortliche",
  map: "Karte",
  myContract: "Mein Vertrag",
  myContacts: "Meine Kontakte",
  myContracts: "Meine Verträge",
  myRegistrationSheet: "Meine Voranmeldungsformulare",
  help: "Online-Hilfe",
  company: "Unternehmen",
  pedagogic_tutor: "Pädagogischer Betreuer",
  company_tutor: "Unternehmensbetreuer",
  apprentice: "Alternant",
  tutor: "Betreuer",
  apprenticeMaster: "Ausbildungsmeister",
  secondary_apprenticeMaster: "Sekundärer Ausbildungsmeister",
  studeaManager: "Pilot",
  legal_responsible: "Gesetzlicher Vertreter",
  studea_ok: "Hefte importiert",
  triad_not_ok: "Nicht importierte Trinômes",
  mission_goal: "Aufgabe und Ziele",
  contract: {
    rupture: {
      title: "Vertragsauflösung",
      title_short: "Auflösung",
      waiting_approuval: "Vertragsauflösung wartet auf Validierung",
      declaration_title: "Erklärung der Vertragsauflösungen",
      declaration_title_short: "Erklärung der Auflösungen",
      add: "Vertragsauflösung erklären",
      add_short: "Auflösung erklären",
      modify: "Diese Vertragsauflösung bearbeiten",
      modify_short: "Diese Auflösung bearbeiten",
      see: "Details der Vertragsauflösung anzeigen",
      see_short: "Vertragsauflösung anzeigen",
      download_rupture_model: "Vorlage für Vertragsauflösung herunterladen",
      declare_at_by: ({ named }) => `Erklärt am ${named("date")} von ${named("user")}`,
      to_valid: "Auflösung zu validieren",
      delete: {
        title: "Diese Vertragsauflösung stornieren",
        confirm: "Möchten Sie diese Vertragsauflösung wirklich stornieren?",
        success: "Vertragsauflösung erfolgreich storniert!",
      },
    },
    dropped_out: {
      title: "Dieses Trinôme hat die Ausbildung am abgebrochen",
      reason: "Grund:",
      comment: "Kommentar:",
      declaration_title: "Ausbildungsabbruch erklären",
      reasons: {
        1: "Umorientierung auf einen anderen Weg",
        2: "Aufgabe des Ausbildungsprojekts",
        3: "Höhere Gewalt (Krankheit, Todesfall usw.)",
        4: "Andere",
      },
      cancel: {
        title: "Abbruch stornieren",
        confirm: "Möchten Sie diesen Abbruch wirklich stornieren?",
        success: "Abbruch erfolgreich storniert!",
      },
      seeking_new_contract: "Auf der Suche nach einem neuen Vertrag",
      signed_new_contract: "Neuer Vertrag unterzeichnet",
      graduation: "Abschluss erworben",
    },
    more: "weitere Informationen",
    empty_date: "Für diesen Vertrag ist kein Datum eingetragen",
    list: ({ named }) => `Liste der Verträge von: ${named("apprentice")}`,
    livret_not_active: "Das Heft wurde für diese Ausbildungsgruppe noch nicht aktiviert",
    livret_deactivate_confirm:
      "Das Heft wird für den Auszubildenden und die anderen Mitglieder des Trinôme unzugänglich, bis es wieder aktiviert wird. Deaktivierung bestätigen?",
    livret_deactivate_success: "Das Heft wurde erfolgreich deaktiviert",
    livret_activate_success: "Das Heft wurde erfolgreich aktiviert",
  },
  sso: {
    click_here: "Klicken Sie hier, um sich in Ihr Konto anzumelden",
    other_profile: "Für alle anderen Profile geben Sie bitte Ihre Studea-Kennung im Feld unten ein",
  },
  secondary_user: {
    list: "Liste der sekundären Benutzer",
  },
  change_year: "Zum Heft des Jahres wechseln:",
};
